import React from 'react';
import TestFileUpload from '../components/TestFileUpload';

const TestUpload: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <TestFileUpload />
      </div>
    </div>
  );
};

export default TestUpload;
